export const GET_LOTS_START = 'GET_LOTS_START';
export const GET_LOTS_SUCCESS = 'GET_LOTS_SUCCESS';
export const GET_LOTS_FAIL = 'GET_LOTS_FAIL';
export const GET_BUILDING_INFO_START = 'GET_BUILDING_INFO_START';
export const GET_BUILDING_INFO_SUCCESS = 'GET_BUILDING_INFO_SUCCESS';
export const GET_BUILDING_INFO_FAIL = 'GET_BUILDING_INFO_FAIL';
export const SET_LOT_SELECTED_ID = 'SET_LOT_SELECTED_ID';
export const SET_LOT_WITH_MODEL_SELECTED = 'SET_LOT_WITH_MODEL_SELECTED';
export const SET_LOTS_SELECTED = 'SET_LOTS_SELECTED';
export const PUSH_LOTS_SELECTED = 'PUSH_LOTS_SELECTED';
export const POP_LOTS_SELECTED = 'POP_LOTS_SELECTED';
export const GET_CO_BROKERS_START = 'GET_CO_BROKERS_START';
export const GET_CO_BROKERS_SUCCESS = 'GET_CO_BROKERS_SUCCESS';
export const GET_CO_BROKERS_FAIL = 'GET_CO_BROKERS_FAIL';
export const GET_SALES_AGENTS_START = 'GET_SALES_AGENTS_START';
export const GET_SALES_AGENTS_SUCCESS = 'GET_SALES_AGENTS_SUCCESS';
export const GET_SALES_AGENTS_FAIL = 'GET_SALES_AGENTS_FAIL';
export const SET_SHOW_AVAILABLE_LOTS = 'SET_SHOW_AVAILABLE_LOTS';

export const GET_FIT_MODELS_SUCCESS = 'GET_FIT_MODELS_SUCCESS';
export const GET_FIT_MODELS_FAIL = 'GET_FIT_MODELS_FAIL';

export const GET_MODEL_LOTS_SUCCESS = 'GET_MODEL_LOTS_SUCCESS';
export const GET_MODEL_LOTS_FAIL = 'GET_MODEL_LOTS_FAIL';

export const SET_LOT_SIZE_TYPE = 'SET_LOT_SIZE_TYPE';
export const SET_FILTERED_LOTS = 'SET_FILTERED_LOTS';
